import React from "react";
import { Star } from "lucide-react";
import { REVIEWS } from "@/data/catalog";
import { SectionHeading } from "@/components/home/SectionHeading";

export const Reviews = () => (
  <section id="reviews" className="bg-[#F8F5EF] py-16 md:py-24" data-testid="reviews">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading overline="Loved by parents" title="Real reviews from real families" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <div
            key={i}
            data-testid={`review-${i}`}
            className="bg-white rounded-3xl p-7 shadow-[0_4px_24px_rgba(111,80,58,0.05)] flex flex-col gap-4"
          >
            <div className="flex gap-0.5">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star
                  key={s}
                  className={`w-4 h-4 ${s < r.rating ? "fill-[#B8C4A3] text-[#B8C4A3]" : "text-[#6F503A]/20"}`}
                />
              ))}
            </div>
            <p className="text-[#6F503A]/80 leading-relaxed">“{r.text}”</p>
            <div className="mt-auto pt-2 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#E9E2D6] flex items-center justify-center font-heading font-semibold text-[#6F503A]">
                {r.name.charAt(0)}
              </div>
              <div>
                <p className="font-medium text-[#6F503A] text-sm">{r.name}</p>
                <p className="text-xs text-[#6F503A]/50">{r.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
